export const SearchFilterHelp: Record<string, string> = {
  general: `
Please provide additional details about the transaction(s) you wish to view.
We will only show you transactions matching this text in one or more of the
Invoice Number, Billing Name, Shipping Name, Email Address, Customer ID,
Description, Last 4 digits of Card Number, or Amount within the date range
you have given.

If this text is a valid Order ID, the transaction will be shown no
matter what date range is selected.`,
  account: `
Please specify an account to view only its transactions; transactions for
multiple accounts can be viewed by clicking the "Add Filter" button and
selecting "or Account" for the filter, listing each account of interest on
a separate filter line.

Dropdown menu will offer valid accounts.

Tip: Start typing any part of the account name or MID to present further
refined suggestions.
`,
  user: `
Please specify a user to view their transactions.

Dropdown menu will offer valid suggestions for users.

Tip: Start typing the name of a user to present further refined suggestions.
`,
  customer: `
  Please specify a customer to view their transactions.

  Dropdown menu will offer valid suggestions for customers.

  Tip: Start typing the name or ID of a customer to present
  further refined suggestions.
`,
  type: `
Please specify the type of transactions you wish to view.

Dropdown menu initially offers all transaction types.

Tip: Clear the input for the full list, or type some letters from the result you want to see
for a refined list.
`,
  method: `
Please specify the method of processing for the transactions you wish to view.

Dropdown menu initially offers all methods of processing.

Tip: Clear the input for the full list, or type some letters from the result you want to see
for a refined list.
`,
  avs: `
Please specify the Address Verification (AVS) response of the transactions you wish to view.

Dropdown menu initially offers all possible AVS results.

Tip: Clear the input for the full list, or type some letters from the result you want to see
for a refined list.
`,
  csc: `
Please specify the Card Security Code (CSC) response of the transactions you wish to view.

Dropdown menu initially offers all possible CSC results.

Tip: Clear the input for the full list, or type some letters from the result you want to see
for a refined list.
`,
}

export type SearchFilterHelpKey = keyof typeof SearchFilterHelp
